// Sticky Cart functionality
class StickyCart {
  constructor() {
    this.stickyCartCount = document.getElementById('sticky-cart-count');
    this.stickyCartIcon = document.getElementById('sticky-cart-icon');
    this.header = document.querySelector('header, .header, .shopify-section-header');
    this.init();
  }

  init() {
    // Subscribe to cart update events
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        // Immediate update, no delay
        this.updateCartCount();
      });
    }

    // Also listen for cart error events
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartError, (event) => {
        // Immediate update on errors too
        this.updateCartCount();
      });
    }

    // Update count on page load
    this.updateCartCount();

    // Add scroll detection for header visibility
    this.initScrollDetection();

    // Faster fallback: Update count more frequently to catch any missed updates
    setInterval(() => {
      this.updateCartCount();
    }, 1000); // Every 1 second instead of 5
  }

  initScrollDetection() {
    if (!this.stickyCartIcon) return;

    // Initially hide the cart icon
    this.stickyCartIcon.classList.remove('show');

    // Throttled scroll handler for better performance
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          this.checkHeaderVisibility();
          ticking = false;
        });
        ticking = true;
      }
    };

    // Listen for scroll events
    window.addEventListener('scroll', handleScroll, { passive: true });
    
    // Check initial state
    this.checkHeaderVisibility();
  }

  checkHeaderVisibility() {
    if (!this.header || !this.stickyCartIcon) return;

    const headerRect = this.header.getBoundingClientRect();
    const headerBottom = headerRect.bottom;

    // Show cart icon when header is completely out of view
    if (headerBottom <= 0) {
      this.stickyCartIcon.classList.add('show');
    } else {
      this.stickyCartIcon.classList.remove('show');
    }
  }

  updateCartCount() {
    // Fetch current cart data
    fetch(`${window.routes.cart_url}.js`)
      .then(response => response.json())
      .then(cart => {
        if (this.stickyCartCount) {
          const itemCount = cart.item_count;
          const currentCount = parseInt(this.stickyCartCount.textContent) || 0;
          
          // Only update if count has changed
          if (itemCount !== currentCount) {
            this.stickyCartCount.textContent = itemCount;
            
            // Add animation class
            this.stickyCartCount.classList.add('updated');
            setTimeout(() => {
              this.stickyCartCount.classList.remove('updated');
            }, 300);
          }

          // Hide count if cart is empty
          if (itemCount === 0) {
            this.stickyCartCount.style.display = 'none';
          } else {
            this.stickyCartCount.style.display = 'flex';
          }
        }
      })
      .catch(error => {
        console.error('Error updating sticky cart count:', error);
      });
  }
}

// Global instance for external access
let stickyCartInstance = null;

// Initialize sticky cart when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  if (document.getElementById('sticky-cart-count')) {
    stickyCartInstance = new StickyCart();
    
    // Make it globally accessible
    window.updateStickyCart = function() {
      if (stickyCartInstance) {
        stickyCartInstance.updateCartCount();
      }
    };
  }
});
